import { render, staticRenderFns } from "./InsuranceAgentDashboard.vue?vue&type=template&id=df725680&scoped=true"
import script from "./InsuranceAgentDashboard.vue?vue&type=script&lang=js"
export * from "./InsuranceAgentDashboard.vue?vue&type=script&lang=js"
import style0 from "./InsuranceAgentDashboard.vue?vue&type=style&index=0&id=df725680&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df725680",
  null
  
)

export default component.exports